import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgWarning = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8 12.5C7.95055 12.5 7.90222 12.5147 7.86111 12.5421C7.82 12.5696 7.78795 12.6086 7.76903 12.6543C7.75011 12.7 7.74516 12.7503 7.7548 12.7988C7.76445 12.8473 7.78826 12.8918 7.82322 12.9268C7.85819 12.9617 7.90273 12.9855 7.95123 12.9952C7.99972 13.0048 8.04999 12.9999 8.09567 12.981C8.14135 12.962 8.1804 12.93 8.20787 12.8889C8.23534 12.8478 8.25 12.7994 8.25 12.75C8.25 12.6837 8.22366 12.6201 8.17678 12.5732C8.12989 12.5263 8.0663 12.5 8 12.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10.5V5.5"
          stroke="currentColor"
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M9.08067 1.17317C8.98146 0.971185 8.82761 0.801045 8.6366 0.682058C8.44559 0.563071 8.22505 0.5 8.00001 0.5C7.77496 0.5 7.55443 0.563071 7.36341 0.682058C7.1724 0.801045 7.01856 0.971185 6.91934 1.17317L0.604006 14.0385C0.527986 14.1932 0.492631 14.3646 0.501278 14.5367C0.509924 14.7088 0.562288 14.8759 0.653425 15.0221C0.744562 15.1684 0.871466 15.289 1.02216 15.3726C1.17285 15.4562 1.34235 15.5 1.51467 15.4998H14.4853C14.6577 15.5 14.8272 15.4562 14.9779 15.3726C15.1285 15.289 15.2555 15.1684 15.3466 15.0221C15.4377 14.8759 15.4901 14.7088 15.4987 14.5367C15.5074 14.3646 15.472 14.1932 15.396 14.0385L9.08067 1.17317Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

export default SvgWarning;
